import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import IconButton from 'components/IconButton';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import oneOccupant from 'assets/icons/one-occupant.svg';
import oneOccupantDark from 'assets/icons/one-occupant-dark.svg';
import twoOccupants from 'assets/icons/two-occupants.svg';
import twoOccupantsDark from 'assets/icons/two-occupants-dark.svg';

import './styles.css';

interface OccupancyTypesProps {
  value: number;
  onChange: (newCapacity: number) => void;
}

class OccupancyTypes extends React.Component<OccupancyTypesProps> {
  onChange = newCapacity => {
    if (this.props.onChange) {
      this.props.onChange(newCapacity);
    }
  };

  onToggleFirst = () => {
    if (this.getSelected().firstSelected) {
      this.onChange(null);
    } else {
      this.onChange(1);
    }
  };

  onToggleSecond = () => {
    if (this.getSelected().secondSelected) {
      this.onChange(null);
    } else {
      this.onChange(2);
    }
  };

  getSelected = () => {
    if (this.props.value === 1) {
      return {firstSelected: true, secondSelected: false};
    }
    if (this.props.value === 2) {
      return {firstSelected: false, secondSelected: true};
    }
    return {firstSelected: false, secondSelected: false};
  };

  render() {
    const {firstSelected, secondSelected} = this.getSelected();

    return (
      <div className="OccupancyTypes">
        <div
          className={classNames(
            'OccupancyTypes__box colab-clickable colab-centered',
            {
              active: firstSelected
            }
          )}
          onClick={this.onToggleFirst}>
          {firstSelected && <img src={oneOccupant} alt="one occupant" />}
          {!firstSelected && <img src={oneOccupantDark} alt="one occupant" />}
        </div>
        <div
          className={classNames(
            'OccupancyTypes__box colab-clickable colab-centered',
            {
              active: secondSelected
            }
          )}
          onClick={this.onToggleSecond}>
          {secondSelected && <img src={twoOccupants} alt="one occupant" />}
          {!secondSelected && <img src={twoOccupantsDark} alt="one occupant" />}
        </div>
      </div>
    );
  }
}

interface CapacityFilterProps {
  value: number;
  onChange: (newCapacity: number) => void;
  classNameForTesting?: string;
}

class CapacityFilter extends React.Component<CapacityFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  render() {
    return (
      <div
        className={classNames(
          'FilterSection CapacityFilter',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Occupancy Type</div>
        </div>

        <div className="FilterSection__content">
          <OccupancyTypes
            value={this.props.value}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    );
  }
}

export default CapacityFilter;
